
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import Axios from 'axios';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Pedidos: Pedido[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Pedidos.Tipos.toTipo( a ), Pedidos: items[a] } );
            }
            return e;
        }

        public get Estado() { return this.Controlador.Buscador.Estado; }
        public Transporte: Transporte = null;

        public Abierto: boolean = false;
        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return this.Seleccionados.filter( x => !x.Envio.Tipo.esRetiraCliente ).hasRows();
        }

        public async Ejecutar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Editar transportes', `¿Sobreescribir el transporte de  ${this.Seleccionados.length} ventas?` ) )
            {
                this.Cargando = true;
                if ( this.Transporte && this.Transporte.Existe )
                {
                    for ( let e of this.Seleccionados )
                    {
                        if ( !e.Envio.Tipo.esRetiraCliente )
                        {
                            e.Envio.EmpresaLogistica = this.Transporte;
                            await e.Envio.save();
                        }
                    }
                    this.Controlador.Buscador.Buscar();
                    this.Controlador.RecargarEstadistica();
                }
                this.Cargando = false;
                this.Cerrar();
            }


        }

        public async Cerrar()
        {
            this.$emit( 'cerrar' );
            this.Abierto = false;

        }
    }
